import { _dataGridConfig } from "../../components/versione2/nica-grid/nica-grid-interface.service";
import { AnaColumn } from "../forms-template.service";


 /* {itemType:"simple",dataField:"dallaData",colSpan:"2"},
          {itemType:"empty",dataField:"",colSpan:"2"},
          {itemType:"simple",dataField:"allaData",colSpan:"2"},
          {itemType:"empty",dataField:"",colSpan:"6"},

          {itemType:"simple",dataField:"stampaDefinitiva",colSpan:"2"},
          {itemType:"simple",dataField:"prossimoProtocolloDaAssegnare",colSpan:"2"},
          {itemType:"simple",dataField:"idModelloDiStampa",colSpan:"2"},
          {itemType:"empty",dataField:"",colSpan:"6"},
          {itemType:"simple",dataField:"stampaDefinitiva",colSpan:"2"},
          {itemType:"simple",dataField:"stampaDefinitiva",colSpan:"2"},
        */
//
export const nicaGridStampaRegistri:_dataGridConfig={
  dataSource:'', // al momento non usato ma servira per griglia statica
  Api:'comune',
  QueryString:'',//  "?filter=siglaprovincia eq 'TO'"
  //key:this.masterKey,  
  form:{
    colCount:'12',
    itemGroup:[
      { type:'group', name:'Group0',caption:'Descrizione Gruppo Primo',colCount:'12',colSpan:'12',
        items:[
          {itemType:"simple",caption:'Ragione Sociale', dataField:'descrizione',colSpan:'6'},
          {itemType:"simple",dataField:"regione", caption:'Regione Ap2',colSpan:"3"},
          //{itemType:"simple",dataField:"regione", caption:'Regione Ap',colSpan:"3"},
          {itemType:"simple",dataField:"siglaProvincia",colSpan:"3"},

          //{itemType:"dxSelectBox",dataField:"regione2", caption:'Regione Ap2',colSpan:"3"},
          //{itemType:"dxSelectBox",dataField:"siglaProvincia2",colSpan:"3"},
          //{itemType:"empty",dataField:"",colSpan:"6"},

          {itemType:"simple",dataField:"catasto",colSpan:"2"},
          {itemType:"simple",dataField:"elencoProvincie",colSpan:"4"},
          //{itemType:"empty",dataField:"",colSpan:"1"},
          {itemType:"simple",dataField:"seCheck",colSpan:"2"},
          {itemType:"simple",dataField:"testoAggiuntivo",colSpan:"4"},
          {itemType:"simple",dataField:"testoAggiuntivoRegionale",colSpan:"6"},
          {itemType:"simple",caption:'Nuova Caption', dataField:"bookedOnArrivalDay",colSpan:"6"},              
          {itemType:"simple",dataField:"priorita",colSpan:"6"},
          {itemType:"simple",dataField:"tag",colSpan:"6"},
          {itemType:"simple",dataField:"switch",colSpan:"3"},
          {itemType:"buttonGroup",dataField:"buttonGroup",colSpan:"3"},
          {itemType:"simple",dataField:"daterange",colSpan:"3"},
          {itemType:"empty",dataField:"",colSpan:"3"},
          {itemType:"button",dataField:"button1",colSpan:"3"},
          {itemType:"button",dataField:"button2", colSpan:"4"},
          {itemType:"button",dataField:"button3", colSpan:"4"},
          //{itemType:"simple",dataField:"desCodicillo",colSpan:"10"},
          //{itemType:"simple",dataField:"note",colSpan:"12"},              
        ]
      },
      { type:'tabs', name:'Group1', caption:'Descrizione Gruppo 2',colCount:'12',colSpan:'12',
        items:[
                {itemType:"title", caption:"Primo Tab", dataField:"",colSpan:"12",                    
                tabs:[
                { 
                  name:'Tab1',
                  title:'Titolo tab',
                  icon:'user',
                  disabled:false,
                  colonneDxDataGrid:[
                    {colSpan:'2', isDataGrid:false,isForm:true, itemType:"simple",dataField:"codicillo"},
                    {colSpan:'10', isDataGrid:false,isForm:true, itemType:"simple",dataField:"desCodicillo"},
                  ]
                },
                { 
                  title:'Titolo tab 2', icon:'user',
                  disabled:true,
                  name:'Tab2',
                  colonneDxDataGrid:[
                    {colSpan:'12',isDataGrid:false,isForm:true, itemType:"simple",dataField:"note",},
                  ]
              }
            ]
          },
          
        ]
      }

    ],
  },
  colonneDxDataGrid:[ //definizione campi per dxdataGrid e per dxo-form
    //buttonGroup
    {
      dataField:'buttonGroup',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"buttonGroup",   
      icon:'save',
      type:'campo',
      optionalButton:[{name:'save' ,text:'Salva Opzioni', type:'success',icon:'save'}],
      caption:'Salva Opzioni',            
      editorOptions:{keyExpr:'alignment', inputAttr:{name:'buttonGroup',NicaGridComponent:this}},          
      onFlyEditorOptions:[/*{ 
        key:'option.disabled',
        indexButton:'1',
        value:"executeFunc=>function(){ if('{{regione}}'=='E') return true;else return false;}",
      },*/]
    },    
    {
      dataField:'daterange',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      caption:'StartFine',          
      editorType: "dxDateBox", 
      //dataType:'date',        
      type:'campo', 
      editorOptions:{disabled: false,valueType:'date',width:'100%',format:'dd/MM/yyyy',inputAttr:{NicaGridComponent:this}},
    },

    {
      dataField:'switch',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      caption:'Swiccia',          
      editorType: "dxSwitch", 
      dataType:'boolean',        
      type:'campo', 
      defaultValue:'false',
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      /*onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
        key:'Nvalue', // opzione da settare per l'input
        value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",                            
      },
    ], */        
    relatedField:[                      
      {
        api:'CurrentData',
        dataField:[],//[{fieldDatasource:'value',fieldDestination:'button1'},], 
        // value indica il valore corrente del campo
        
        //executeFunc:"function(){return value;}",            
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){\
          return { button1:{editorOption:{disabled:value}},message:'ok'};  \
        }"

      },
    ],
    },
    {
      dataField:'button1',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"button",   
      icon:'save',
      type:'campo',
      optionalButton:[{name:'save' ,text:'Salva Opzioni', type:'success',icon:'save'}],
      caption:'Salva Opzioni',            
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},          
      eventi:[]
    },         
    {
      dataField:'button2',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"button",    
      icon:'back',
      optionalButton:[{name:'back' ,text:'Recupera Opzioni', type:'danger',icon:'back'}],
      type:'campo',
      caption:'Recupera Opzioni',             
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      eventi:[]
    },     
    {
      dataField:'button3',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"button",    
      icon:'comment',
      optionalButton:[{name:'comment' ,type:'default',text:'Cancella Opzioni q', icon:'comment'}],
      type:'campo',
      caption:'Cancella Opzioni A',             
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      eventi:[{
        event:'onClick',
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let miaF='clikkone'; alert('Scommetto che hai clikkato');parent.SettaOptionGruppo('Group1','visible',false);parent.settaEditorOptionsGroupButton('buttonGroup','disabled',0,true); parent.SettaOptionTabs('Tab2','disabled',false);parent.itemOptions[field]['disabled']=true;parent.updateCell(parent.CurrentRowIndexEdit,field,true);parent.callBackScript({message:'ok'});return {message:'ok'}  }"
        
      }]
    },           
    {
      dataField:'note',
      isDataGrid:false,          
      isForm:true,
      editorType:'dxTextBox',
      
      editorOptions:{disabled: false,height:50,inputAttr:{NicaGridComponent:this}},
    }, 
    {
      //
      dataField:'desCodicillo',
      caption:'Descrizione EER',
      colVisible:false,
      editorType:'dxTextBox',
      type:'campo',
      isForm:true,
      isDataGrid:false,
      /*onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
        key:'disabled', // opzione da settare per l'input
        value:"executeFunc=>function(){if('{{value}}'=='E') return true}",
      }],  */
    editorOptions:{disabled: true,inputAttr:{NicaGridComponent:this}},
        
    },
    {
      dataField:'codicillo',
      caption:'Codicillo',
      colVisible:false,
      isDataGrid:false,
      defaultValue:'150101', // per nuovo
      isForm:true,   
      editorType:'dxTextBox',
      type:'campo',       
     
    
    optionalButton:[      
      { 
        eventi:[{
          event:'onClick',
          ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let miaF='clikkone'; alert('Scommetto che hai clikkato in alto a destra');return {message:'ok'}  }"         
        }],name:'CercaDescrizione',hint:'Cerca Descrizione',icon:'user',location:'after'      
      }

    ],         

      editorOptions:{            
        width:'80px',disabled: false,inputAttr:{NicaGridComponent:this}
      },  
      relatedField:[{
        api:'apiweb',//'apiweb|'+environment.BASE_API_URL+'cer',
        queryString:'cer/{{value}}',            
        // la fieldDestinazione se simile a xxx.disabled si intende opzione altrimenti si setta ilvalore
        dataField:[{fieldDatasource:'descrizione',fieldDestination:'desCodicillo'}],
        //esegue la routine dopo la call API 
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput)\
        {let tipo='success';\
        let result=externalData.descrizione;if(externalData.pericoloso==true) {tipo='danger';result=externalData.descrizione+' *';}return {desCodicillo:{value:result},button2:{editorOption:{disabled:externalData.pericoloso,type:tipo}},message:'Ritorno dal futuro'};}"}]                    
    },

    {
      dataField:'priorita',
      caption:'Priorità',          
      editorType:'dxRadioGroup', 
      dataType:'boolean',        
      type:'campo', 
      isDataGrid:false,
      isForm:true,   
      editorOptions:{            
        dataSource:[
          { id: 0, text: 'Adesso' },
          { id: 1, text: 'Domani' },
          { id: 2, text: 'Forse' },
          { id: 3, text: 'Kissa' }],
          layout:'horizontal', valueExpr: 'id', displayExpr: 'text',
          disabled: false,inputAttr:{NicaGridComponent:this}
      },  
      onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
          key:'disabled', // opzione da settare per l'input
          value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",                            
        },
      ],
      relatedField:[            
      {          
        api:'CurrentData',
        dataField:[{fieldDatasource:'priorita',fieldDestination:'testoAggiuntivo'}], 
      },
      {
        api:'CurrentData',
        dataField:[{fieldDatasource:'priorita',fieldDestination:'bookedOnArrivalDay'},], 
        // value indica il valore corrente del campo
        executeFunc:"function(){if('{{value}}'=='1') return 'hai selezionato 1'; else return 'Hai selezionato '+value;}",
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){parent.SettaOptionTabs('Tab2','disabled',value==0);return {message:'ok'}  }"

      },
    ],
      eventi:[]
    },
    {
      dataField:'seCheck',
      caption:'Check Test',
      colVisible:true,
      editorType:'dxCheckBox',
      dataType:'boolean',
      type:'dxCheckBox', 
      isForm:true,
      isDataGrid:true,
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},  
      onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
          key:'disabled', // opzione da settare per l'input
          value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
        },
        { // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
          key:'value,disabled', // opzione da settare per l'input
          value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
        },
      ],            
      eventi:[]
    },
    {
    dataField:'descrizione',
    caption:'Descrizione 1',               
    colVisible:true,
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true, 
    optionalButton:[{name:'',hint:'Cerca Descrizione',icon:'user',location:'after'}],                                
    /*
buttons: [{name: 'cerca',location: 'after',  inputAttr:{name:'buttonGroup',NicaGridComponent:this},options:{onClick: ($event) => {const data = $event.component.option('elementAttr');
    console.log("data",$event);alert('clikkatooo')},icon: 'user',stylingMode: 'text'}}],
  optionalButton:[{name:'',hint:'Cerca Descrizione',icon:'user',location:'after'}],                                

    */
//    editorOptions:{buttons:[{name:'cerca',location: 'after',options:{icon:'user'}}],disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        


    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
      key:'disabled',  // setta editor option
      value:"executeFunc=>function(){return !{{$this.isNewRow}};}",        
      }
  ], 
  },{       
    itemType:"empty",
    colVisible:true,
    type:'empty',
    isForm:true,
    isDataGrid:false,
  },
  {
    //template:'Provincie', // legge le impostazioni non funzionaaaaaaaaa
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
    dataField:'siglaProvincia',
    caption:'Provincia',
    colVisible:true,
    isForm:true,
    isDataGrid:true,
    editorType:'dxSelectBox',        
    type:'campo',
    dxolookup:{         
      api:"Provincia",
      displayExpr:'descrizione',
      valueExpr:'siglaProvincia',
      filter:"?$filter=idRegione eq '{{regione}}'",
    }

  },  
  //---------------------------  Test Select Box ------------------
  
    {
    //template:'Provincie', // legge le impostazioni non funzionaaaaaaaaa
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
    dataField:'siglaProvincia2',
    caption:'Provincia2',
    colVisible:true,
    isForm:true,
    isDataGrid:true,
    editorType:'dxSelectBox',        
    type:'dxSelectBox',
    dxolookup:{         
      api:"Provincia",
      displayExpr:'descrizione',
      valueExpr:'siglaProvincia',
      filter:"?$filter=idRegione eq '{{regione2}}'",
    }

  },  

  {
    dataField:'regione2',
    caption:'Regione 2',
    colVisible:true,
    editorType:'dxSelectBox',
    type:'dxSelectBox',
    isForm:true,
    isDataGrid:true,
    defaultValue:'P', // per nuovo
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    relatedField:[{ // permette di cambiare valori di altri campi in base a quello corrente         
      api:'CurrentDs',  // CurrentDs se lista ,CurrentData form o nome  apiweb
      dataField:[{fieldDatasource:'elencoProvincie',fieldDestination:'elencoProvincie'}],          
      valore:'value', // indica il valore corrente
                      // in pratica esegue un foreach sul current dataset e se key è uguale al valore stampa la relativa field
      key:'id'  // si riferisce alla key del datasource corrente da comparere con value
      // probabilmente non servirà a niente ??          
    },
    {          
      api:'CurrentData',
      dataField:[{fieldDatasource:'value',fieldDestination:'button1.disabled'}], 
      executeFunc:"function(){if('{{value}}'=='E') return true; else return false;}"
    },
    {          
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivo'}], 
    },
    {
      // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
      // value indica il valore corrente del campo
      executeFunc:"function(){if('{{value}}'=='E') return 'hai selezionato la regione E'; else return 'Hai sbagliato Regione';}"
    },
  ],
    dxolookup:{         
      api:'regione',
      displayExpr:'descrizione',
      valueExpr:'id',
      cascating:{  // dxolookup related 
        api:"Provincia?$filter=idRegione eq '{{value}}'&order='descrizione'",
        dataField:'siglaProvincia2',
        filter:"" //?$filter=idRegione eq '{{value}}'&order='descrizione'",
      }
    }
  },
  //---------------------------  End Test Select Box ------------------
  {
    dataField:'regione',
    caption:'Regione',
    colVisible:true,
    editorType:'dxSelectBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    defaultValue:'P', // per nuovo
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    relatedField:[{ // permette di cambiare valori di altri campi in base a quello corrente         
      api:'CurrentDs',  // CurrentDs se lista ,CurrentData form o nome  apiweb
      dataField:[{fieldDatasource:'elencoProvincie',fieldDestination:'elencoProvincie'}],          
      valore:'value', // indica il valore corrente
                      // in pratica esegue un foreach sul current dataset e se key è uguale al valore stampa la relativa field
      key:'id'  // si riferisce alla key del datasource corrente da comparere con value
      // probabilmente non servirà a niente ??          
    },
    {          
      api:'CurrentData',
      dataField:[{fieldDatasource:'value',fieldDestination:'button1.disabled'}], 
      executeFunc:"function(){if('{{value}}'=='E') return true; else return false;}"
    },
    {          
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivo'}], 
    },
    {
      // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
      // value indica il valore corrente del campo
      executeFunc:"function(){if('{{value}}'=='E') return 'hai selezionato la regione E'; else return 'Hai sbagliato Regione';}"
    },
  ],
    dxolookup:{         
      api:'regione',
      displayExpr:'descrizione',
      valueExpr:'id',
      cascating:{  // dxolookup related 
        api:'Provincia',
        dataField:'siglaProvincia',
        filter:"?$filter=idRegione eq '{{value}}'&order='descrizione'",
      }
    }
  },{
    dataField:'catasto',
    caption:'Catasto',
    colVisible:true,        
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
        key:'disabled',
        value:"executeFunc=>function(){if('{{regione}}'=='E') return true}",
    }],         
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    
  },{        
    dataField:'elencoProvincie',
    caption:'Provincie',
    colVisible:true,
    editorType:'dxTextBox',
    isForm:true,
    isDataGrid:true,        
    type:'campo',
    
    editorOptions:{disabled: true,inputAttr:{NicaGridComponent:this}},        
    
  },{
    dataField:'testoAggiuntivo',
    caption:'Testo Aggiuntivo',
    colVisible:false,
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
      key:'disabled', // opzione da settare per l'input
      value:"executeFunc=>function(){if('{{value}}'=='E') return true}",
  }],  
  editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    
  },
  {
    //
    dataField:'testoAggiuntivoRegionale',
    caption:'Testo Aggiuntivo Regionale',
    colVisible:false,
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
      key:'disabled', // opzione da settare per l'input
      value:"executeFunc=>function(){if('{{value}}'=='E') return true}",
    }],  
  editorOptions:{disabled: true,inputAttr:{NicaGridComponent:this}},
  },
  {
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    isDataGrid:false,
    isForm:true,   
    dataField:'bookedOnArrivalDay',
    type:'campo',
    caption:'Nuova Descrizione',
    editorType:'dxTextBox', 
    relatedField:[
    {
      // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
      // value indica il valore corrente del campo
     
      executeFunc:"function(){if('{{value}}'=='1') return 'hai selezionato 1'; else return 'non Hai selezionato 1';}"
    },
  ],       
  },
  //1 mx.greensymposium.it.
  //greenmedsymposium-it.mail.protection.outlook.com.
  {
    isDataGrid:false,
    isForm:true,   
    dataField:'tag',
    type:'campo',
    caption:'Tag Box',
    editorType:'dxTagBox', 
    editorOptions:{
      disabled: false,inputAttr:{NicaGridComponent:this},
      showSelectionControls:true,
      applyValueMode:"useButtons",
      displayExpr:"text",
      valueExpr:"id",
      dataSource:[
        { id: 0, text: 'Adesso' },
        { id: 1, text: 'Domani' },
        { id: 2, text: 'Forse' },
        { id: 3, text: 'Kissa' }],
    },
    relatedField:[
      {
        // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
        api:'CurrentData',
        dataField:[{fieldDatasource:'value',fieldDestination:'testoAggiuntivoRegionale'},], 
        // value indica il valore corrente del campo
        executeFunc:"function(){return {{value}}.join(',');}"
      },
    ],   
    

  }
]      
}  

export const nicaGridComuni:_dataGridConfig={
  dataSource:'', // al momento non usato ma servira per griglia statica
  Api:'comune',
  QueryString:'',//  "?filter=siglaprovincia eq 'TO'"
  //key:this.masterKey,  
  form:{
    colCount:'12',
    headerHtml: "<div style=\"max-width:688px;text-align:center;margin: 16px auto;\">\n\n<div style=\"padding:0 24px;\">\n<h4>Test Nica Grid.</h4>\n<br>\n<p>Testo Letto dalla configurazione e visualizzato all'inizio della form, potrebbe essere parametrizzato in base a quanche input del componente o magari a dati dinamici del tipo {variabile}. Tutto da fare</p>\n</div>\n\n</div>\n",
    itemGroup:[
      { type:'group', name:'Group0',caption:'Descrizione Gruppo 11',colCount:'12',colSpan:'12',
        items:[
          {itemType:"simple",caption:'Ragione Sociale',dataField:'descrizione',colSpan:'6'},
          {itemType:"simple",dataField:"regione", caption:'Regione Ap2',colSpan:"3"},
          {itemType:"simple",dataField:"siglaProvincia",colSpan:"3"},
          //{itemType:"empty",dataField:"",colSpan:"6"},
          {itemType:"simple",dataField:"catasto",colSpan:"2"},
          {itemType:"simple",dataField:"elencoProvincie",colSpan:"4"},
          //{itemType:"empty",dataField:"",colSpan:"1"},
          {itemType:"simple",dataField:"seCheck",colSpan:"2"},
          {itemType:"simple",dataField:"testoAggiuntivo",colSpan:"4"},
          {itemType:"simple",dataField:"testoAggiuntivoRegionale",colSpan:"6"},
          {itemType:"simple",caption:'Nuova Caption', dataField:"bookedOnArrivalDay",colSpan:"6"},              
          {itemType:"simple",dataField:"priorita",colSpan:"6"},
          {itemType:"simple",dataField:"tag",colSpan:"6"},
          {itemType:"simple",dataField:"switch",colSpan:"3"},
          {itemType:"buttonGroup",dataField:"buttonGroup",colSpan:"3"},
          {itemType:"simple",dataField:"daterange",colSpan:"3"},
          {itemType:"empty",dataField:"",colSpan:"3"},
          {itemType:"button",dataField:"button1",colSpan:"3"},
          {itemType:"button",dataField:"button2", colSpan:"4"},
          {itemType:"button",dataField:"button3", colSpan:"4"},
          //{itemType:"simple",dataField:"desCodicillo",colSpan:"10"},
          //{itemType:"simple",dataField:"note",colSpan:"12"},              
        ]
      },
      { type:'tabs', name:'Group1', caption:'Descrizione Gruppo 2',colCount:'12',colSpan:'12',
        items:[
                {itemType:"title", caption:"Primo Tab", dataField:"",colSpan:"12",                    
                tabs:[
                { 
                  name:'Tab1',
                  title:'Titolo tab',
                  icon:'user',
                  disabled:false,
                  colonneDxDataGrid:[
                    {colSpan:'2', isDataGrid:false,isForm:true, itemType:"simple",dataField:"codicillo"},
                    {colSpan:'10', isDataGrid:false,isForm:true, itemType:"simple",dataField:"desCodicillo"},
                  ]
                },
                { 
                  title:'Titolo tab 2', icon:'user',
                  disabled:true,
                  name:'Tab2',
                  colonneDxDataGrid:[
                    {colSpan:'12',isDataGrid:false,isForm:true, itemType:"simple",dataField:"note",},
                  ]
              }
            ]
          },
          
        ]
      }

    ],
  },
  colonneDxDataGrid:[ //definizione campi per dxdataGrid e per dxo-form
    //buttonGroup
    {
      dataField:'buttonGroup',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"buttonGroup",   
      icon:'save',
      type:'campo',
      optionalButton:[{name:'save' ,text:'Salva Opzioni', type:'success',icon:'save'}],
      caption:'Salva Opzioni',            
      editorOptions:{keyExpr:'alignment', inputAttr:{name:'buttonGroup',NicaGridComponent:this}},          
      onFlyEditorOptions:[/*{ 
        key:'option.disabled',
        indexButton:'1',
        value:"executeFunc=>function(){ if('{{regione}}'=='E') return true;else return false;}",
      },*/]
    },    
    {
      dataField:'daterange',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      caption:'StartFine',          
      editorType: "dxDateBox", 
      //dataType:'date',        
      type:'campo', 
      editorOptions:{disabled: false,valueType:'date',width:'100%',format:'dd/MM/yyyy',inputAttr:{NicaGridComponent:this}},
    },

    {
      dataField:'switch',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      caption:'Swiccia',          
      editorType: "dxSwitch", 
      dataType:'boolean',        
      type:'campo', 
      defaultValue:'false',
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      /*onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
        key:'Nvalue', // opzione da settare per l'input
        value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",                            
      },
    ], */        
    relatedField:[                      
      {
        api:'CurrentData',
        dataField:[],//[{fieldDatasource:'value',fieldDestination:'button1'},], 
        // value indica il valore corrente del campo
        
        //executeFunc:"function(){return value;}",            
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){\
          return { button1:{editorOption:{disabled:value}},message:'ok'};  \
        }"

      },
    ],
    },
    {
      dataField:'button1',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"button",   
      icon:'save',
      type:'campo',
      optionalButton:[{name:'save' ,text:'Salva Opzioni', type:'success',icon:'save'}],
      caption:'Salva Opzioni',            
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},          
      eventi:[]
    },         
    {
      dataField:'button2',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"button",    
      icon:'back',
      optionalButton:[{name:'back' ,text:'Recupera Opzioni', type:'danger',icon:'back'}],
      type:'campo',
      caption:'Recupera Opzioni',             
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      eventi:[ //parent.SettaOptionGruppo('Group1','visible',false);\
        {
          event:'onClick',
          //ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let miaF='clikkone'; alert('Scommetto che hai clikkato');parent.SettaOptionGruppo('Group1','visible',false);parent.settaEditorOptionsGroupButton('buttonGroup','disabled',0,true); parent.SettaOptionTabs('Tab2','disabled',false);parent.itemOptions[field]['disabled']=true;parent.updateCell(parent.CurrentRowIndexEdit,field,true);parent.callBackScript({message:'ok'});return {message:'ok'}  }"
          ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput)\
          {\
            parent.settaEditorOptionsGroupButton('buttonGroup','disabled',0,false);\
           }"
        }
      ]
    },     
    {
      dataField:'button3',
      isDataGrid:false,
      isForm:true,
      colVisible:false,
      itemType:"button",    
      icon:'comment',
      optionalButton:[{name:'comment' ,type:'default',text:'Cancella Opzioni f', icon:'comment'}],
      type:'campo',
      //caption:'Cancella Opzioni w',             
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      eventi:[{
        event:'onClick',
        //ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let miaF='clikkone'; alert('Scommetto che hai clikkato');parent.SettaOptionGruppo('Group1','visible',false);parent.settaEditorOptionsGroupButton('buttonGroup','disabled',0,true); parent.SettaOptionTabs('Tab2','disabled',false);parent.itemOptions[field]['disabled']=true;parent.updateCell(parent.CurrentRowIndexEdit,field,true);parent.callBackScript({message:'ok'});return {message:'ok'}  }"
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput)\
        {let miaF='clikkone'; alert('Scommetto che hai clikkato '+parent.CurrentRowIndexEdit);\
         parent.settaEditorOptionsGroupButton('buttonGroup','disabled',0,true);\
         parent.callBackScript({message:'ok'});\
         return {message:'ok'}  }"
      }]
    },           
    {
      dataField:'note',
      isDataGrid:false,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,height:50,inputAttr:{NicaGridComponent:this}},
    }, 
    {
      //
      dataField:'desCodicillo',
      caption:'Descrizione EER',
      colVisible:false,
      editorType:'dxTextBox',
      type:'campo',
      isForm:true,
      isDataGrid:false,      

      /*onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
        key:'disabled', // opzione da settare per l'input
        value:"executeFunc=>function(){if('{{value}}'=='E') return true}",
      }],  */
    editorOptions:{caption:'Descrizione AEER', disabled: true,inputAttr:{NicaGridComponent:this}},
        
    },
    {
      dataField:'codicillo',
      caption:'Codicillo',
      colVisible:false,
      isDataGrid:false,
      defaultValue:'150101', // per nuovo
      isForm:true,   
      editorType:'dxTextBox',      
      type:'campo',    
      optionalButton:[      
        {           
          eventi:[{
            event:'onClick',
            ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let miaF='clikkone'; alert('Scommetto che hai clikkato in basso a destra');return {desCodicillo:{value:'Aprire Componenete di ricerca'},message:'ok'}  }"         
          }],name:'CercaEEEEEERRRRR',hint:'Cerca EEERRRRR',icon:'user',location:'after'      
        }
  
      ],           
   
      editorOptions:{            
        width:'80px',disabled: false,inputAttr:{NicaGridComponent:this}
      },  
      relatedField:[{
        api:'apiweb',//'apiweb|'+environment.BASE_API_URL+'cer',
        queryString:'cer/{{value}}',            
        // la fieldDestinazione se simile a xxx.disabled si intende opzione altrimenti si setta ilvalore
        dataField:[{fieldDatasource:'descrizione',fieldDestination:'desCodicillo'}],
        //esegue la routine dopo la call API         
        onError:"{return {desCodicillo:{value:''},message:'Ritorno dal futuro'};}", 
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput)\
        {let tipo='success';\
        let result=externalData.descrizione;if(externalData.pericoloso==true) {tipo='danger';result=externalData.descrizione+' *';}return {desCodicillo:{value:result},button2:{editorOption:{disabled:externalData.pericoloso,type:tipo}},message:'Ritorno dal futuro'};}"}]                    
    },

    {
      dataField:'priorita',
      caption:'Priorità',          
      editorType:'dxRadioGroup', 
      dataType:'boolean',        
      type:'campo', 
      isDataGrid:false,
      isForm:true,   
      editorOptions:{            
        dataSource:[
          { id: 0, text: 'Adesso' },
          { id: 1, text: 'Domani' },
          { id: 2, text: 'Forse' },
          { id: 3, text: 'Kissa' }],
          layout:'horizontal', valueExpr: 'id', displayExpr: 'text',
          disabled: false,inputAttr:{NicaGridComponent:this}
      },  
      onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
          key:'disabled', // opzione da settare per l'input
          value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",                            
        },
      ],
      relatedField:[            
      {          
        api:'CurrentData',
        dataField:[{fieldDatasource:'priorita',fieldDestination:'testoAggiuntivo'}], 
      },
      {
        api:'CurrentData',
        dataField:[{fieldDatasource:'priorita',fieldDestination:'bookedOnArrivalDay'},], 
        // value indica il valore corrente del campo
        executeFunc:"function(){if('{{value}}'=='1') return 'hai selezionato 1'; else return 'Hai selezionato '+value;}",
        ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){parent.SettaOptionTabs('Tab2','disabled',value==0);return {message:'ok'}  }"
        
      },
    ],
      eventi:[]
    },
    {
      dataField:'seCheck',
      caption:'Check Test',
      colVisible:true,
      editorType:'dxCheckBox',
      dataType:'boolean',
      type:'dxCheckBox', 
      isForm:true,
      isDataGrid:true,
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},  
      onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
          key:'disabled', // opzione da settare per l'input
          value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
        },
        { // viene eseguita in onEditorPreparing del campo e cambia EditorOptions
          key:'value,disabled', // opzione da settare per l'input
          value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
        },
      ],            
      eventi:[]
    },
    {
    dataField:'descrizione',
    caption:'Descrizione 2',               
    colVisible:true,
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,     
    optionalButton:[      
      { 
        name:'CercaDescrizione',hint:'Cerca Descrizione',icon:'save',location:'after',
        eventi:[{
          event:'onClick',
          ExecuteRoutine:"function(field,externalData,newData,value,currentRowData,parent,allParameterInput){let miaF='clikkone'; alert('Hai clikkato in alto a destra per ricercare 22');return {regione:{value:'P'},message:'ok'}  }"         
        }]
      }

    ],                                
    /*
buttons: [{name: 'cerca',location: 'after',  inputAttr:{name:'buttonGroup',NicaGridComponent:this},options:{onClick: ($event) => {const data = $event.component.option('elementAttr');
    console.log("data",$event);alert('clikkatooo')},icon: 'user',stylingMode: 'text'}}],
  optionalButton:[{name:'',hint:'Cerca Descrizione',icon:'user',location:'after'}],                                

    */
//    editorOptions:{buttons:[{name:'cerca',location: 'after',options:{icon:'user'}}],disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        


    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
      key:'disabled',  // setta editor option
      value:"executeFunc=>function(){return !{{$this.isNewRow}};}",        
      }
  ], 
  },{       
    itemType:"empty",
    colVisible:true,
    type:'empty',
    isForm:true,
    isDataGrid:false,
  },
  {
    //template:'Provincie', // legge le impostazioni non funzionaaaaaaaaa
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
    dataField:'siglaProvincia',
    caption:'Provincia',    
    colVisible:true,
    isForm:true,
    isDataGrid:true,
    editorType:'dxSelectBox',        
    type:'campo',
    dxolookup:{         
      api:"Provincia",
      displayExpr:'descrizione',
      valueExpr:'siglaProvincia',
      filter:"?$filter=idRegione eq '{{regione}}'",
    }

  },  
  //---------------------------  Test Select Box ------------------
  
    

  
  //---------------------------  End Test Select Box ------------------
  {
    dataField:'regione',
    caption:'Regione',
    colVisible:true,
    editorType:'dxSelectBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    defaultValue:'P', // per nuovo
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    relatedField:[{ // permette di cambiare valori di altri campi in base a quello corrente         
      api:'CurrentDs',  // CurrentDs se lista ,CurrentData form o nome  apiweb
      dataField:[{fieldDatasource:'elencoProvincie',fieldDestination:'elencoProvincie'}],          
      valore:'value', // indica il valore corrente
                      // in pratica esegue un foreach sul current dataset e se key è uguale al valore stampa la relativa field
      key:'id'  // si riferisce alla key del datasource corrente da comparere con value
      // probabilmente non servirà a niente ??          
    },
    {          
      api:'CurrentData',
      dataField:[{fieldDatasource:'value',fieldDestination:'button1.disabled'}], 
      executeFunc:"function(){if('{{value}}'=='E') return true; else return false;}"
    },
    {          
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivo'}], 
    },
    {
      // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
      // value indica il valore corrente del campo
      executeFunc:"function(){if('{{value}}'=='E') return 'hai selezionato la regione E'; else return 'Hai sbagliato Regione';}"
    },
  ],
    dxolookup:{         
      api:'regione',
      displayExpr:'descrizione',
      valueExpr:'id',
      cascating:{  // dxolookup related 
        api:'Provincia',
        dataField:'siglaProvincia',
        filter:"?$filter=idRegione eq '{{value}}'&order='descrizione'",
      }
    }
  },{
    dataField:'catasto',
    caption:'Catasto',
    colVisible:true,        
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
        key:'disabled',
        value:"executeFunc=>function(){if('{{regione}}'=='E') return true}",
    }],         
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    
  },{        
    dataField:'elencoProvincie',
    caption:'Provincie',
    colVisible:true,
    editorType:'dxTextBox',
    isForm:true,
    isDataGrid:true,        
    type:'campo',
    
    editorOptions:{disabled: true,inputAttr:{NicaGridComponent:this}},        
    
  },{
    dataField:'testoAggiuntivo',
    caption:'Testo Aggiuntivo 2',
    colVisible:false,
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
      key:'disabled', // opzione da settare per l'input
      value:"executeFunc=>function(){if('{{value}}'=='E') return true else return false}",
  }],  
  editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    
  },
  {
    //
    dataField:'testoAggiuntivoRegionale',
    caption:'Testo Aggiuntivo Regionale',
    colVisible:false,
    editorType:'dxTextBox',
    type:'campo',
    isForm:true,
    isDataGrid:true,
    onFlyEditorOptions:[{ // viene eseguita in onEditorPreparing del campo
      key:'disabled', // opzione da settare per l'input
      value:"executeFunc=>function(){if('{{value}}'=='E') return true}",
    }],  
  editorOptions:{disabled: true,inputAttr:{NicaGridComponent:this}},
  },
  {
    editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    isDataGrid:false,
    isForm:true,   
    dataField:'bookedOnArrivalDay',
    type:'campo',
    caption:'Nuova Descrizione',
    editorType:'dxTextBox', 
    relatedField:[
    {
      // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
      api:'CurrentData',
      dataField:[{fieldDatasource:'regione',fieldDestination:'testoAggiuntivoRegionale'},], 
      // value indica il valore corrente del campo
     
      executeFunc:"function(){if('{{value}}'=='1') return 'hai selezionato 1'; else return 'non Hai selezionato 1';}"
    },
  ],       
  },
  //1 mx.greensymposium.it.
  //greenmedsymposium-it.mail.protection.outlook.com.
  {
    isDataGrid:false,
    isForm:true,   
    dataField:'tag',
    type:'campo',
    caption:'Tag Box',
    editorType:'dxTagBox', 
    editorOptions:{
      disabled: false,inputAttr:{NicaGridComponent:this},
      showSelectionControls:true,
      applyValueMode:"useButtons",
      displayExpr:"text",
      valueExpr:"id",
      dataSource:[
        { id: 0, text: 'Adesso' },
        { id: 1, text: 'Domani' },
        { id: 2, text: 'Forse' },
        { id: 3, text: 'Kissa' }],
    },
    relatedField:[
      {
        // value:"executeFunc=>function(){if('{{regione}}'=='E') return true; else return false;}",
        api:'CurrentData',
        dataField:[{fieldDatasource:'value',fieldDestination:'testoAggiuntivoRegionale'},], 
        // value indica il valore corrente del campo
        executeFunc:"function(){return {{value}}.join(',');}"
      },
    ],   
    

  }
]      
}   
export const contattiWeb:_dataGridConfig={
  dataSource:'', // al momento non usato ma servira per griglia statica
  Api:'https://www.rentri.website/apirest/contatti',
  QueryString:'',//  "?filter=siglaprovincia eq 'TO'"
  key:'Cod',  
  form:{
    colCount:'12',
    headerHtml: "<div style=\"max-width:688px;text-align:center;margin: 16px auto;\">\n\n<div style=\"padding:0 24px;\">\n<h4>Test Nica Grid.</h4>\n<br>\n<p>Testo Letto dalla configurazione e visualizzato all'inizio della form, potrebbe essere parametrizzato in base a quanche input del componente o magari a dati dinamici del tipo {variabile}. Tutto da fare</p>\n</div>\n\n</div>\n",
    itemGroup:[
      { type:'group', name:'Group0',caption:'Contatto',colCount:'12',colSpan:'12',
        items:[
          {itemType:"simple",caption:'Ragione Sociale',dataField:'RagSoc',colSpan:'6'},
          {itemType:"simple",dataField:"Est", caption:'Etensione Ragione Sociale',colSpan:"6"},
          {itemType:"simple",dataField:"id_regione",colSpan:"4"},
          {itemType:"simple",dataField:"id_provincia",colSpan:"3"},
          {itemType:"simple",dataField:"id_localita",colSpan:"5"},
          //{itemType:"empty",dataField:"",colSpan:"6"},
          {itemType:"simple",caption:'Partita IVA',dataField:"PIva",colSpan:"2"},
          {itemType:"simple",caption:'Codice Fiscale',dataField:"Cf",colSpan:"4"},
          //{itemType:"empty",dataField:"",colSpan:"1"},
          {itemType:"simple",caption:'Disabilitato',dataField:"Disabilitato",colSpan:"2"},
          {itemType:"simple",dataField:"Annot1",colSpan:"4"},
          {itemType:"simple",dataField:"Annot2",colSpan:"6"},
        ]
      }
    ],
  },
  colonneDxDataGrid:[ //definizione campi per dxdataGrid e per dxo-form
    {
      dataField:'RagSoc',
      isDataGrid:true,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    }, 
    {
      dataField:'Est',
      isDataGrid:true,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    }, 

    {
      dataField:'id_regione',
      caption:'Regione',
      colVisible:true,
      editorType:'dxSelectBox',
      type:'campo',
      isForm:true,
      isDataGrid:true,
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
      dxolookup:{         
        api:'https://www.rentri.website/apirest/regioni',
        displayExpr:'nome',
        valueExpr:'id',
        /*cascating:{  // dxolookup related 
          api:'https://www.rentri.website/apirest/province',
          dataField:'id_provincia',
          filter:"?$filter=id_regione eq '{{value}}'",
        }*/
      }
    },

    {
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
      dataField:'id_provincia',
      caption:'Provincia',    
      colVisible:true,
      isForm:true,
      isDataGrid:true,
      editorType:'dxSelectBox',        
      type:'campo',
      dxolookup:{         
        api:'https://www.rentri.website/apirest/Province',
        displayExpr:'sigla_automobilistica',
        valueExpr:'id',
        filter:"?$filter=id_regione eq '{{id_regione}}'",
        cascating:{  // dxolookup related 
          api:'https://www.rentri.website/apirest/comuni',
          dataField:'id_localita',
          filter:"?$filter=id_provincia eq '{{id_provincia}}'",
        }
      }  
    },  
    {
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}}, // obbligatorio        
      dataField:'id_localita',
      caption:'Località',    
      colVisible:true,
      isForm:true,
      isDataGrid:true,
      editorType:'dxSelectBox',        
      type:'campo',
      dxolookup:{         
        api:"https://www.rentri.website/apirest/comuni",
        displayExpr:'nome',
        valueExpr:'id',
        filter:"?$filter=id_provincia eq '{{id_provincia}}'",
      }
    }, 
    {
      dataField:'PIva',
      isDataGrid:true,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    },  
    {
      dataField:'Cf',
      isDataGrid:true,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    },  
    {
      dataField:'Disabilitato',
      caption:'Disabilitato',
      colVisible:true,
      editorType:'dxCheckBox',
      dataType:'boolean',
      type:'dxCheckBox', 
      isForm:true,
      isDataGrid:true,
      editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},  
    },

    {
      dataField:'Annot1',
      isDataGrid:true,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,height:50,inputAttr:{NicaGridComponent:this}},
    }, 
    {
      dataField:'Annot2',
      isDataGrid:true,          
      isForm:true,
      editorType:'dxTextBox',
      editorOptions:{disabled: false,height:50,inputAttr:{NicaGridComponent:this}},
    }, 
]      
}  


